export class StsChangePassword {
    existingPassword: string;
    newPassword: string;
    confirmPassword: string;
}
